import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMadeEasy = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "madeEasyForEveryone",
	xmlns: "http://www.w3.org/2000/svg",
	width: 30,
	height: 30,
	viewBox: "0 0 30 30",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			id: "Path_12504",
			"data-name": "Path 12504",
			d: "M0,0H30V30H0Z",
			fill: "none"
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Path_12505",
			"data-name": "Path 12505",
			d: "M8,13V25.5",
			transform: "translate(2 -4.25)",
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Path_12506",
			"data-name": "Path 12506",
			d: "M12,7v7.543",
			transform: "translate(3 6.707)",
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Path_12507",
			"data-name": "Path 12507",
			d: "M16,10v3.037",
			transform: "translate(4 8.213)",
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("path", {
			id: "Path_12508",
			"data-name": "Path 12508",
			d: "M5.5,3H23a2.5,2.5,0,0,1,2.5,2.5V23A2.5,2.5,0,0,1,23,25.5H5.5A2.5,2.5,0,0,1,3,23V5.5A2.5,2.5,0,0,1,5.5,3Z",
			transform: "translate(0.75 0.75)",
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 2
		})
	]
});
export default SvgMadeEasy;
